// extracted by mini-css-extract-plugin
export default {"root":"lG1Wnsil","title":"ruIvhAsa","value":"gcEJxstT","up":"hiorl4_d","down":"igkA4m9d"};